import './Modal.scss';
import * as React from 'react';
import { TestableInterface } from '../interfaces/TestableInterface';
import { Button } from '../Button/Button';
import classNames from 'classnames';

export interface ModalState {
  isOpen: boolean;
}

export interface ModalPropsInterface extends TestableInterface {
  preventDrop: boolean;
  isOpen: boolean;
  fullscreen?: boolean;
  header?: string;
  headerJSX?: JSX.Element;
  className?: string;
  closeOnOverlayClick?: boolean;
  content?: any;
  closeButtonLabel?: string;
  showCloseIcon?: boolean;
  index?: number;
  onClose?: () => void;
  size?: 'wide' | 'medium' | 'small';
}

export class Modal extends React.Component<ModalPropsInterface, ModalState> {
  constructor(props: ModalPropsInterface) {
    super(props);

    this.state = {
      isOpen: props.isOpen
    };
  }

  public static defaultProps: ModalPropsInterface = {
    preventDrop: false,
    isOpen: false,
    automation: '',
    onClose: () => null,
    size: 'wide'
  };

  private handleOnClose() {
    this.setState({ isOpen: false });
    this.props.onClose();
  }

  private getFooterFromChildren() {
    let children = this.props.children;
    if (!children) { return null; }
    if (!Array.isArray(children)) { children = [children]; }
    // @ts-ignore
    return children.filter((c) => !!c).reduce((a, e) => a || (e.type === 'footer' ? e : null), null);
  }

  private getChildrenWithoutFooter() {
    let children = this.props.children;
    if (!children) { return null; }
    if (!Array.isArray(children)) { children = [children]; }
    // @ts-ignore
    return children.filter((c) => !!c).filter((e) => e.type !== 'footer');
  }

  public render(): JSX.Element {
    const danger = { __html: this.props.content };

    const numChildren = React.Children.count(this.props.children);

    let header: JSX.Element;
    let footer;
    let content;
    let closeIcon;
    if (this.props.headerJSX) {
      header = this.props.headerJSX;
    } else if (this.props.header) {
      header = (
        <div className="header">
          <h1>{this.props.header}</h1>
        </div>
      );
    }

    footer = this.getFooterFromChildren();

    if (!footer && this.props.closeButtonLabel) {
      footer = (
        <div className="footer">
          <Button
            label={this.props.closeButtonLabel}
            action={() => {
              this.handleOnClose();
            }}
            automation={this.props.automation + '-closebtn'}
          />
        </div>
      );
    }

    if (this.props.content) {
      content = (
        <div className="content" dangerouslySetInnerHTML={danger}>
        </div>
      );
    } else if (numChildren > 0) {
      content = (
        <div className="content">
          {this.getChildrenWithoutFooter()}
        </div>
      );
    }

    if (this.props.showCloseIcon) {
      closeIcon = <a className="Button close" onClick={() => { this.handleOnClose(); }}>X</a>;
    }

    if (this.props.isOpen) {
      return (
        <div className="Modal"
          onDragOver={(e) => this.props.preventDrop && e.preventDefault()}
          onDrop={(e) => this.props.preventDrop && e.preventDefault()}>
          <div className={classNames('Modal', 'overlay')}
            style={{ zIndex: 3000 + (((this.props.index * 2) || 0)) }}
            onClick={() => {
              if (this.props.closeOnOverlayClick) {
                this.handleOnClose();
              }
            }}>
          </div>
          <div className={classNames('Modal', 'window', this.props.size, this.props.className,
            { fullscreen: this.props.fullscreen })}
            style={{ zIndex: 3001 + (((this.props.index * 2) || 0)) }}>
            {header}
            {content}
            {footer}
            {closeIcon}
          </div>
        </div>
      );
    } else {
      return (
        <div />
      );

    }
  }
}
